/** Pengaturan visual global — warna zona lebih jernih tanpa tint gelap */
export const VISUAL_THEME = {
  /** Phaser tint 0xffffff = warna asli texture (paling jernih) */
  bgClear: 0xffffff,
  zoneWarmth: {
    zone1: 0xfff5e1,
    zone2: 0xeaf8ee,
    zone3: 0xfff0df,
    zone4: 0xe8f4f8,
    zone5: 0xf5f6e8,
    ending: 0xf7f1dc,
  },
  pathAlpha: 0.8,
  grassOverlayAlpha: 0.3,
  menuDimAlpha: 0.14,
} as const;
